//---------- Application -----------------------------
export const START_LOADING='START_LOADING'
export const STOP_LOADING='STOP_LOADING'
export const START_VALIDATE_TAGS = 'START_VALIDATE_TAGS'
export const ADD_TAG_ERROR='ADD_TAG_ERROR'
export const SET_LOCK_TAB_IR='SET_LOCK_TAB_IR'
export const SET_UNLOCK_TAB_IR='SET_UNLOCK_TAB_IR'
export const SET_LOCK_TAB_PO='SET_LOCK_TAB_PO'
export const SET_UNLOCK_TAB_PO='SET_UNLOCK_TAB_PO'
export const CLEAR_STATUS_TAB='CLEAR_STATUS_TAB'

export const ERROR_401 ='ERROR_401'


//---------- Security -----------------------------
export const LOGIN_START = 'LOGIN_START'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'

//---------- Master Data --------------------------
export const MASTER_CLEAR ='MASTER_CLEAR'
export const GET_EMPLOYEE_INFO = 'GET_EMPLOYEE_INFO'
export const GET_SEARCH_DIRECTORY_INFO = 'GET_SEARCH_DIRECTORY_INFO'
// export const GET_PLANT_INFO = 'GET_PLANT_INFO'
export const GET_BUSINESS_PLACE = 'GET_BUSINESS_PLACE'
export const GET_GL_ACCOUNT = 'GET_GL_ACCOUNT'
export const GET_COST_CENTER = 'GET_COST_CENTER'
export const GET_ASSET = 'GET_ASSET'
export const GET_VAT = 'GET_VAT'
export const GET_CURRENCY_CODE = 'GET_CURRENCY_CODE'
export const GET_PAYMENT_METHOD = 'GET_PAYMENT_METHOD'
export const GET_PAYMENT_SUPPLEMENT = 'GET_PAYMENT_SUPPLEMENT'
export const GET_PAYMENT_TERM = 'GET_PAYMENT_TERM'
export const GET_WITH_CODE = 'GET_WITH_CODE'
export const GET_REGION = "GET_REGION"
export const GET_COUNTRY = "GET_COUNTRY"
export const GET_BANKBRANCH = "GET_BANKBRANCH"
export const GET_BANKNAME = "GET_BANKNAME"
export const GET_MASTER_VAT = "GET_MASTER_VAT"
export const GET_MR_FORM = "GET_MR_FORM"
export const GET_MR_VENDORTYPE = "GET_MR_VENDORTYPE"
export const GET_MR_REF_LIST = "GET_MR_REF_LIST"
export const GET_MR_PO_STATUS = "GET_MR_PO_STATUS"
export const GET_MR_REF_DATA = "GET_MR_REF_DATA"
export const GET_MR_REF_VENDOR = "GET_MR_REF_VENDOR"
export const GET_SLOC_WITH_PLANTS="GET_SLOC_WITH_PLANTS"
export const GET_VENDOR="GET_VENDOR"
export const GET_UNIT_UOM="GET_UNIT_UOM"
export const GET_ASSET_CLASS="GET_ASSET_CLASS"
export const GET_RESON_EVAL = "GET_RESON_EVAL"
export const GET_WHT_VALIDATE = "GET_WHT_VALIDATE"
export const GET_MASTER_REJECTOPTION = 'GET_MASTER_REJECTOPTION'
//---------- Transaction -----------------------------
export const UPDATE_TRANSACION = 'UPDATE_TRANSACTION'

//---------- PO (Purchase Order) -----------------------------
export const CLEAR_PO='CLEAR_PO'
export const SEARCH_PO = 'SEARCH_PO'
export const SEARCH_PO_COMPLETED = 'SEARCH_PO_COMPLETED'
export const SEARCH_PO_FAIL = 'SEARCH_PO_FAIL'
export const SEARCH_PO_ORIGINAL = 'SEARCH_PO_ORIGINAL'

//---------- GR (Goods Receive) -----------------------------
export const UPDATE_GR_DETAIL = 'UPDATE_GR_DETAIL'
export const UPDATE_GR_ITEM = 'UPDATE_GR_ITEM'
export const UPDATE_GR_SERVICE_ITEM = 'UPDATE_GR_SERVICE_ITEM'
export const UPDATE_GR_SERVICE_LINE = 'UPDATE_GR_SERVICE_LINE'
export const UPDATE_GR_ITEM_ACCOUNT_ASSIGNMENT = 'UPDATE_GR_ITEM_ACCOUNT_ASSIGNMENT'
export const UPDATE_GR_SERVICE_ACCOUNT_ASSIGNMENT = 'UPDATE_GR_SERVICE_ACCOUNT_ASSIGNMENT'
export const UPDATE_GR_ITEM_MODAL = 'UPDATE_GR_ITEM_MODAL'
export const UPDATE_GR_SERVICELINE_MODAL = 'UPDATE_GR_SERVICELINE_MODAL'
export const SELECT_ITEM_GR_SERVICE = 'SELECT_ITEM_GR_SERVICE'

//---------- Upload File -----------------------------
export const UPLOAD_FILE = 'UPLOAD_FILE'
export const GET_FILE = 'GET_FILE'
export const CLEAR_FILE = 'CLEAR_FILE'
export const DELETE_FILE = 'DELETE_FILE'

//------------ MyTask -------------------------------
export const GET_MYTASK = 'GET_MYTASK'
export const GET_INPROGRESS = 'GET_INPROGRESS'
export const UPDATE_STATUS_TRANSACION  = 'UPDATE_STATUS_TRANSACION'


//------------ MR (Material Receive) -------------------------------
export const UPDATE_MR_DETAIL = 'UPDATE_MR_DETAIL'
export const UPDATE_MR_VENDOR = 'UPDATE_MR_VENDOR'
export const CLEAR_MR_VENDOR = 'CLEAR_MR_VENDOR'
export const UPDATE_MR_ATTACHMENT = 'UPDATE_MR_ATTACHMENT'
export const UPDATE_MR_IR_DESCRIPTION = 'UPDATE_MR_IR_DESCRIPTION'
export const UPDATE_MR_EVAL_CHANGE = 'UPDATE_MR_EVAL_CHANGE'

//------------ MR (EVAL) -------------------------------
export const UPDATE_MR_EVAL = 'UPDATE_MR_EVAL'

//Modal Evaluation
export const UPDATE_EVALUATION_MODAL = "UPDATE_EVALUATION_MODAL"
export const CLEAR_EVALUATION_MODAL = "CLEAR_EVALUATION_MODAL"

//New Asset
export const UPDATE_NEW_ASSET ='UPDATE_NEW_ASSET'
export const SET_ASSET_MODAL_OPTIONS='SET_ASSET_MODAL_OPTIONS'

//---------- Message Box -----------------------------
export const MSG_SHOW_ERROR='MSG_SHOW_ERROR'
export const MSG_SHOW_WARNING='MSG_SHOW_WARNING'
export const MSG_SHOW_SUCCESS='MSG_SHOW_SUCCESS'
export const MSG_SHOW_INFO='MSG_SHOW_INFO'
export const MSG_SHOW_WARNING_SAVE='MSG_SHOW_WARNING_SAVE'
export const MSG_CONFIRM_SHOW='MSG_CONFIRM_SHOW'
export const MSG_CONFIRM_HIDE='MSG_CONFIRM_HIDE'
export const MSG_HIDE_WARNING_SAVE='MSG_HIDE_WARNING_SAVE'


//-----------IR -----------
export const UPDATE_IR_ONE_TIME_VENDOR = "UPDATE_IR_ONE_TIME_VENDOR"
export const UPDATE_IR_ONE_TIME_VENDOR_MODAL = "UPDATE_IR_ONE_TIME_VENDOR_MODAL"
export const GET_IR_REFERENCE = "GET_IR_REFERENCE"

//-----------Search -----------
export const GET_REPORT_ON_SCREEN = 'GET_REPORT_ON_SCREEN'
export const GET_EXPORT_REPORT = 'GET_EXPORT_REPORT' 
export const GET_PDF_REPORT = 'GET_PDF_REPORT'
export const GET_PDF_REPORT_COMMITTEE = 'GET_PDF_REPORT_COMMITTEE'
export const GET_REPORT_OUTSTANDING_ON_SCREEN = 'GET_REPORT_OUTSTANDING_ON_SCREEN'
export const GET_EXPORT_OUTSTANDING_REPORT = 'GET_EXPORT_OUTSTANDING_REPORT'

//-----------USER-------------
export const SET_USER_DATA = "SET_USER_DATA"
export const UPDATE_USER_MODAL = "UPDATE_USER_MODAL"
export const SET_USER_FAIL = "SET_USER_FAIL"
export const GET_USER = "GET_USER"
export const GET_ALL_USER = "GET_ALL_USER"
export const GET_ORG_UNIT = "GET_ORG_UNIT"
export const ERROR_USER_FAIL = "ERROR_USER_FAIL"

//-----------USER-------------
export const SET_USER_MANUAL_DATA = "SET_USER_MANUAL_DATA"
export const UPDATE_USER_MANUAL_MODAL = "UPDATE_USER_MANUAL_MODAL"
export const SET_USER_MANUAL_FAIL = "SET_USER_MANUAL_FAIL"
export const GET_USER_MANUAL = "GET_USER_MANUAL"
export const GET_ALL_USER_MANUAL = "GET_ALL_USER_MANUAL"
export const ERROR_USER_MANUAL_FAIL = "ERROR_USER_MANUAL_FAIL"

//-----------Modal Employee-------------
export const MODAL_EMPLOYEE_KEY_VALUE = "MODAL_EMPLOYEE_KEY_VALUE"
export const MODAL_EMPLOYEE_INPUT_EMPCODE = "MODAL_EMPLOYEE_INPUT_EMPCODE"
export const MODAL_EMPLOYEE_INPUT_EMPNAME = "MODAL_EMPLOYEE_INPUT_EMPNAME"
export const MODAL_EMPLOYEE_INPUT_POSITION = "MODAL_EMPLOYEE_INPUT_POSITION"
export const MODAL_EMPLOYEE_INPUT_POSITIONABBR = "MODAL_EMPLOYEE_INPUT_POSITIONABBR"
export const MODAL_EMPLOYEE_INPUT_DEPARTMENTCODE = "MODAL_EMPLOYEE_INPUT_DEPARTMENTCODE"
export const MODAL_EMPLOYEE_INPUT_DEPARTMENTNAME = "MODAL_EMPLOYEE_INPUT_DEPARTMENTNAME"
export const MODAL_EMPLOYEE_INPUT_DEPARTMENTABBR = "MODAL_EMPLOYEE_INPUT_DEPARTMENTABBR"

//-----------Modal Vendor-------------
export const MODAL_VENDOR_KEY_VALUE = "MODAL_VENDOR_KEY_VALUE"
export const MODAL_VENDOR_INPUT_EMPCODE = "MODAL_VENDOR_INPUT_EMPCODE"
export const MODAL_VENDOR_INPUT_EMPNAME = "MODAL_VENDOR_INPUT_EMPNAME"
export const MODAL_VENDOR_SET_RESULT = "MODAL_VENDOR_SET_RESULT"
//-----------Modal CostCneter-------------
export const MODAL_COSTCENTER_KEY_VALUE     = "MODAL_COSTCENTER_KEY_VALUE"
export const MODAL_COSTCENTER_INPUT_SEARCH  = "MODAL_COSTCENTER_INPUT_SEARCH"
export const MODAL_COSTCENTER_SET_RESULT    = "MODAL_COSTCENTER_SET_RESULT"

//-----------DepartmentMap-------------
export const GET_DEPARTMETMAP_ALL          = "GET_DEPARTMETMAP_ALL"
export const GET_DEPARTMETMAP              = "GET_DEPARTMETMAP"
export const UPDATE_DEPARTMETMAP_MODAL     = "UPDATE_DEPARTMETMAP_MODAL"
export const ERROR_DEPARTMENTMAP_FAIL      = "ERROR_USER_FAIL"
export const UPDATE_DEPARTMETMAP           = "UPDATE_DEPARTMETMAP"
export const CREATE_DEPARTMETMAP           = "CREATE_DEPARTMETMAP"
export const DELETE_DEPARTMETMAP           = "DELETE_DEPARTMETMAP"
export const SET_DEPARTMETMAP              = "SET_DEPARTMETMAP"
export const DEPARTMETMAP_SUCCESS          = "DEPARTMETMAP_SUCCESS"


//-----------Unit Reviewer-------------
export const GET_ALL_UNIT_REVIEWER          = "GET_ALL_UNIT_REVIEWER"
export const GET_UNIT_REVIEWER              = "GET_UNIT_REVIEWER"
export const UPDATE_UNIT_REVIEWER           = "UPDATE_UNIT_REVIEWER"
export const CREATE_UNIT_REVIEWER           = "CREATE_UNIT_REVIEWER"
export const DELETE_UNIT_REVIEWER           = "DELETE_UNIT_REVIEWER"
export const ERROR_UNIT_REVIEWER_FAIL       = "ERROR_UNIT_REVIEWER_FAIL"
export const UNIT_REVIEWER_SUCCESS          = "UNIT_REVIEWER_SUCCESS"
export const UPDATE_UNIT_REVIEWER_MODAL     = "UPDATE_UNIT_REVIEWER_MODAL"

//-----------Doc Control-------------
export const SET_ACTIVE_PO                  = "SET_ACTIVE_PO"
export const SET_NOT_ACTIVE_PO              = "SET_NOT_ACTIVE_PO"
export const GET_DOC_CONTROL                = 'GET_GET_DOC_CONTROL'
export const SET_PO_CONTRACT                 = "SET_PO_CONTRACT"
export const GET_PO_CONTRACT                 = "GET_PO_CONTRACT"

//-----------ContractPO-------------
export const SET_M_YEAR_END_PO = "SET_M_YEAR_END_PO"
export const SET_M_YEAR_END_PO_FAIL="SET_M_YEAR_END_PO_FAIL"
export const ERROR_M_YEAR_END_PO_FAIL="ERROR_M_YEAR_END_PO_FAIL"
export const UPDATE_LOCK_PO_MODAL="UPDATE_LOCK_PO_MODAL"
export const UPLOAD_SUCCESS="UPLOAD_SUCCESS"

export const GET_IS_ACCEPT                  = "GET_IS_ACCEPT"
export const GET_IS_PO_ACCEPT               = "GET_IS_PO_ACCEPT"
export const SET_IS_ACCEPT                  = "SET_IS_ACCEPT"
export const SET_IS_PO_ACCEPT               = "SET_IS_PO_ACCEPT"

//-----------Email Template-------------
export const GET_EMAIL_TEMPLATE = "GET_EMAIL_TEMPLATE"
export const GET_EMAIL_TEMPLATE_ID = "GET_EMAIL_TEMPLATE_ID"
export const SET_EMAIL_TEMPLATE = "SET_EMAIL_TEMPLATE"
